import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { sectionPath } from "../../../utils";
import { CustomLink } from "../../custom-link";
import "./story-section.module.css";

export const StorySection = ({ story, config, template = "" }) => {
  const section = get(story, ["sections", 0]);
  const supportedTemplates = ["simple", "background"];
  const templateStyle = supportedTemplates.includes(template) ? `link--${template}` : "link";
  if (!section) return null;
  const mountAtPrefix = config.mountAt || "";
  const domainSlug = useSelector(state => get(state, ["qt", "config", "domainSlug"], ""), shallowEqual);
  return (
    <CustomLink
      data-testid="section-name"
      styleName={templateStyle}
      href={`${mountAtPrefix}/` + sectionPath(config, section, domainSlug)}
    >
      {section["display-name"] || section["name"]}
    </CustomLink>
  );
};

StorySection.propTypes = {
  story: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  template: PropTypes.oneOf(["simple", "background"])
};
